<input style="display: none" type="text" name="fakeusernameremembered" />
<input style="display: none" type="password" name="fakepasswordremembered" />
<router-outlet></router-outlet>
<p-toast key="tst" [baseZIndex]="99999"></p-toast>
<p-confirmDialog [baseZIndex]="99999"></p-confirmDialog>

<div class="footer copyright text-center">
    <img
    src="assets/img/footer.png"
    class="mb-5 mt-5 px-4"
    />
</div>